import { setContext, ContextSetter } from 'apollo-link-context';
import { createQueryAndMutateFunctions } from './common';
import { ENDPOINTS } from '@/settings/endpoints';

export const dexAuth: ContextSetter = (_, { headers }) => {
  const token = localStorage.getItem('token');

  if (token) {
    return {
      headers: {
        ...headers,
        authorization: `Bearer ${token.replace(/"/g, '')}`,
      },
    };
  }
  return headers;
};

const dexAuthLink = setContext(dexAuth);

export const { query: dexQuery, mutate: dexMutation } = createQueryAndMutateFunctions(
  ENDPOINTS.dexGraphql,
  dexAuthLink,
);
